<template>
    <div class="form-group-scoped">
        <div class="form-item">
            <label class="label-caption">Coordenadas</label>

            <div class="field-label field-label-center">
                {{ formatarCoordenada(latitude) }}
                x
                {{ formatarCoordenada(longitude) }}
            </div>
        </div>

        <button
            type="button"
            class="buttom-icon--map"
            aria-label="Selecionar coordenadas no mapa"
            @click="showMapaModal = true"
        ></button>
    </div>

    <MapaCoordenadaModal
        :is-open="showMapaModal"
        :coordenadas-iniciais="coordenadasIniciais"
        :show-marker="temCoordenadas"
        @close="showMapaModal = false"
        @coordenadaSelecionada="setCoordenadas"
    />
</template>

<script setup>
import { computed, ref } from "vue";
import { globalStore } from "@/globals";
import MapaCoordenadaModal from "./modals/MapaCoordenadaModal.vue";

const props = defineProps({
    modelValueLatitude: Number,
    modelValueLongitude: Number,
});

const emit = defineEmits([
    "update:modelValueLatitude",
    "update:modelValueLongitude",
]);

const showMapaModal = ref(false);

const latitude = computed(() => props.modelValueLatitude ?? null);
const longitude = computed(() => props.modelValueLongitude ?? null);

const temCoordenadas = computed(
    () => latitude.value != null && longitude.value != null
);

const coordenadasIniciais = computed(() => ({
    lat: latitude.value ?? globalStore.latitude ?? -28.935225,
    lng: longitude.value ?? globalStore.longitude ?? -49.485324,
}));

function formatarCoordenada(valor) {
    return valor == null ? "--" : valor.toFixed(6);
}

function setCoordenadas({ lat, lng }) {
    emit("update:modelValueLatitude", Number(lat.toFixed(6)));
    emit("update:modelValueLongitude", Number(lng.toFixed(6)));

    showMapaModal.value = false;
}
</script>

<style scoped>
.form-group-scoped {
    align-items: end;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex: 1;
}
</style>